export default {
    type: 'add',
    title: 'Добавление подарочного сертификата',
    loading: false,
    add_payment: false,
    tab: 'form',
}